export default "__VITE_ASSET__CkbJTjAf__"